/* @flow */
import { isEmpty } from 'lodash';
import * as React from 'react';

import AvatarWithTextItem from 'components/AvatarWithTextItem';
import AvatarWithTextItems from 'components/AvatarWithTextItems';
import Button from 'components/Button.jsx';
import Icon from 'components/Icon.jsx';
import TooltipTrigger from 'components/TooltipTrigger.jsx';
import PeopleListProfile from 'components/PeopleList/PeopleListProfile';
import Group from 'entities/Group';
import User from 'entities/User';
import GroupAvatarWithText from 'groups/components/GroupAvatarWithText';

import './PeopleListGroupProfile.scss';

import type {
  ClassProfile_classes,
  ClassProfile_classes_members,
  ClassProfile_classes_owners,
  ClassProfile_classes_organization,
} from '../queries/__generated__/ClassProfile.js';

type Props = {
  group: ClassProfile_classes,
  onBackClicked: ?() => void,
  onUserClicked: (userId: number, organizationUuid: string) => void,
  onClose: () => void,
};

export default class PeopleListGroupProfile extends React.Component<Props> {
  renderGroupMembersList = (
    members:
      | $ReadOnlyArray<ClassProfile_classes_owners>
      | $ReadOnlyArray<ClassProfile_classes_members>,
    organization: ?ClassProfile_classes_organization
  ) => {
    if (isEmpty(members)) {
      return null;
    }

    const { onUserClicked } = this.props;

    return (
      <AvatarWithTextItems>
        {members.map(member => (
          <AvatarWithTextItem
            subtle
            user={User.fromJSON(member.user)}
            key={member.user.id}
            onClick={() => organization && onUserClicked(member.user.id, organization.uuid)}
          />
        ))}
      </AvatarWithTextItems>
    );
  };

  render() {
    const { group, onBackClicked, onClose } = this.props;
    const { className, hasRosterSource, members, owners, organization } = group;

    const userIsInGroup = false;
    const groupEntity = Group.fromJSON(group);

    const joinLeaveButtonProps = {
      full: true,
    };

    return (
      <PeopleListProfile
        onBackClicked={onBackClicked}
        onClose={onClose}
        actions={
          userIsInGroup ? (
            <Button {...joinLeaveButtonProps} color="lava" level="secondary">
              Leave {className}
            </Button>
          ) : (
            <Button {...joinLeaveButtonProps} level="primary">
              Join {className}
            </Button>
          )
        }
        header={
          <GroupAvatarWithText
            avatarSize="large"
            icon={
              <TooltipTrigger
                placement="top"
                tooltip={hasRosterSource ? 'SIS-linked' : 'Not SIS-linked'}>
                <span>
                  <Icon
                    color={hasRosterSource ? 'shamrock' : 'koala'}
                    name="link-linked"
                    size="xlarge"
                  />
                </span>
              </TooltipTrigger>
            }
            group={groupEntity}
            level="primary"
          />
        }
        sections={[
          {
            title: 'Class owners',
            children: this.renderGroupMembersList(owners, organization),
            count: owners.length,
          },
          {
            title: 'Class members',
            children: this.renderGroupMembersList(members, organization),
            count: members.length,
          },
          {
            title: 'Last announcement',
            children: <div>TODO</div>,
          },
        ]}
        className="PeopleListGroupProfile"
      />
    );
  }
}
